import './financing-step.scss';

import { ChosenLeasingInfo } from './feature';
import { CurrentLeasingView } from './widgets';

const FinancingStep: React.FC = () => {
  return (
    <div className="ie-financing-step">
      <div className="ie-financing-step__content">
        <div className="ie-financing-step__header">
          <h2 className="ie-financing-step__title">Документы</h2>
        </div>

        <div className="ie-financing-step__bank-view">
          <CurrentLeasingView />
        </div>
      </div>

      <div className="ie-financing-step__side">
        <ChosenLeasingInfo />
      </div>
    </div>
  );
};

export default FinancingStep;
